'use client'

import {
   Badge,
   Box,
   Card,
   Container,
   SimpleGrid,
   Stack,
   Text,
   ThemeIcon
} from '@blocks'
import {
   siteSectionBodyHex,
   siteSectionCardRadiusPx,
   siteSectionHeadingHex,
   siteTextOnDarkBandHex,
   siteTextOnDarkBandMutedHex,
   siteTypographySectionLeadFontSizeDesktop,
   siteTypographySectionLeadFontSizeMobile,
   siteTypographySectionTitlePrimaryFontSizeDesktop,
   siteTypographySectionTitlePrimaryFontSizeMobile
} from '@constants'
import {useMediaQuery} from '@hooks'
import {IconWind} from '@icons'
import {FaqInSection} from '@/blocks/site/FaqAccordion'

const vacuums = [
   {
      title: 'Fragranced Vacuum',
      description:
         'Leaves your vehicle smelling fresh with a clean, pleasant scent after every use.'
   },
   {
      title: 'Turbo Vacuum',
      description:
         'Delivers extra suction power for a more thorough removal of dust, dirt, and debris.'
   }
]

export const VacuumStations = () => {
   const isMobile = useMediaQuery('(max-width: 768px)')

   return (
      <Box bg={'primary.9'}>
         <Container
            id={'vacuum'}
            py={isMobile ? 80 : 120}
            size={'xl'}
            style={{scrollMarginTop: 120}}
         >
            <Stack gap={isMobile ? 50 : 60}>
               <Stack
                  align={'center'}
                  gap={12}
               >
                  <Badge
                     size={'lg'}
                     fw={700}
                     tt={'uppercase'}
                     styles={{
                        root: {
                           backgroundColor: 'rgba(255,255,255,0.12)',
                           color: 'white',
                           border: '1px solid rgba(255,255,255,0.22)'
                        }
                     }}
                  >
                     Vacuum Stations
                  </Badge>
                  <Text
                     c={siteTextOnDarkBandHex}
                     fz={
                        isMobile
                           ? siteTypographySectionTitlePrimaryFontSizeMobile
                           : siteTypographySectionTitlePrimaryFontSizeDesktop
                     }
                     fw={800}
                     lh={1.05}
                     ta={'center'}
                  >
                     Finish the Job.
                  </Text>
                  <Text
                     c={siteTextOnDarkBandMutedHex}
                     fz={
                        isMobile
                           ? siteTypographySectionLeadFontSizeMobile
                           : siteTypographySectionLeadFontSizeDesktop
                     }
                     fw={500}
                     lh={1.7}
                     ta={'center'}
                     maw={600}
                  >
                     Finish the job with our on-site vacuum stations
                     and leave your vehicle feeling fresh inside as
                     well. Whether you need a quick tidy-up or a more
                     thorough clean, our vacuums help remove dust,
                     dirt, and debris throughout.
                  </Text>
               </Stack>

               <SimpleGrid
                  cols={{base: 1, sm: 2}}
                  spacing={isMobile ? 20 : 28}
               >
                  {vacuums.map((vacuum) => (
                     <Card
                        key={vacuum.title}
                        p={isMobile ? 32 : 40}
                        radius={siteSectionCardRadiusPx}
                        bg={'white'}
                        style={{
                           boxShadow:
                              '0 6px 28px rgba(10, 55, 121, 0.1)',
                           border: '1px solid #e2e8f4'
                        }}
                     >
                        <Stack gap={20}>
                           <ThemeIcon
                              p={12}
                              size={60}
                              color={siteSectionHeadingHex}
                              variant={'light'}
                              radius={'lg'}
                           >
                              <IconWind
                                 stroke={1.6}
                                 size={32}
                              />
                           </ThemeIcon>
                           <Text
                              c={siteSectionHeadingHex}
                              fz={
                                 isMobile
                                    ? siteTypographySectionLeadFontSizeMobile
                                    : siteTypographySectionLeadFontSizeDesktop
                              }
                              fw={700}
                           >
                              {vacuum.title}
                           </Text>
                           <Text
                              c={siteSectionBodyHex}
                              fz={
                                 isMobile
                                    ? siteTypographySectionLeadFontSizeMobile
                                    : siteTypographySectionLeadFontSizeDesktop
                              }
                              fw={500}
                              lh={1.6}
                           >
                              {vacuum.description}
                           </Text>
                        </Stack>
                     </Card>
                  ))}
               </SimpleGrid>
               <FaqInSection
                  categoryPriority={'vacuum-stations'}
                  sectionTone={'dark'}
               />
            </Stack>
         </Container>
      </Box>
   )
}
